<template>
  <div>
    <v-card class="mx-auto my-4" max-width="550">
      <v-card-title v-if="loading">
        Processing payment, please wait...
      </v-card-title>
      <v-row v-if="loading">
        <v-col
          cols="12"
          style="height: 50vh"
          class="d-flex justify-center align-center"
        >
          <v-progress-circular :size="50" indeterminate color="primary">
          </v-progress-circular>
        </v-col>
      </v-row>
      <v-card-text>
        <v-alert type="error" outlined v-if="errorMsg != ''">
          <v-row align="center">
            <v-col class="grow">
              <span>{{ errorMsg }}</span>
            </v-col>
            <v-col class="shrink">
              <v-btn color="primary" to="/gopro">try again</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sessionId: "",
      subscription: "",
      status: "",
      loading: true,
      errorMsg: "",
    };
  },
  mounted() {
    this.$utils.visit(this);
    // get session_id query param from the url
    console.log("Query params: " + JSON.stringify(this.$route.query));
    this.sessionId = this.$route.query.session_id;
    this.subscription = this.$route.query.subscription;
    this.retrieveCheckoutSessionStatus();
  },
  methods: {
    async retrieveCheckoutSessionStatus() {
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/api/retrieve-checkout-session",
          {
            sessionId: this.sessionId,
          },
        );
        // e.g. resp = { status: "complete" }
        console.log(
          "/api/retrieve-checkout-session resp: " + JSON.stringify(resp),
        );
        this.status = resp.status;
        if (this.status === "complete") {
          try {
            for (let i = 0; i < 5; i++) {
              var resp = await this.$utils.callBackendPost(
                this,
                "/api/getProStatus",
                {},
              );
              console.log("getUserProStatus resp: " + JSON.stringify(resp));
              if (resp.isPro) {
                break;
              } else {
                // wait for 3 seconds before next try
                await new Promise((resolve) => setTimeout(resolve, 3000));
              }
            }
            // on success, setIsPro in store and redirect to propanel with welcome message
            this.$utils.trackEvent("subscribe_pro", {
              plan: this.subscription,
            });
            // Google Ads conversion tracking (Purchase). session_id is unique per
            // checkout, so it's used as transaction_id to prevent double-counting.
            this.$utils.trackEvent("conversion", {
              send_to: "AW-18400989503/i4tgCLerkekcEL-io8ZE",
              transaction_id: this.sessionId,
            });
            this.$store.commit("setIsPro", true);
            this.$router.push({
              path: "propanel",
              query: { welcome: "true" },
            });
          } catch (error) {
            this.errorMsg = error;
          } finally {
            this.loading = false;
          }

          // // if checkout session is complete, call backend to set user as pro
          // try {
          //   this.loading = true;
          //   await this.$utils.callBackendPost(this, "/api/buyPro", {
          //     proOption: this.subscription,
          //   });
          //   // on success, setIsPro in store and redirect to propanel with welcome message
          //   this.$store.commit("setIsPro", true);
          //   this.$router.push({
          //     path: "propanel",
          //     query: { welcome: "true" },
          //   });
          // } catch (error) {
          //   this.errorMsg = error;
          // }
          // // on success, setIsPro in store and redirect to propanel with welcome message
          // this.$store.commit("setIsPro", true);
          // this.$router.push({
          //   path: "propanel",
          //   query: { welcome: "true" },
          // });
        } else {
          // something went wrong with the checkout session, show error message and give btn to try again
          this.errorMsg =
            "Checkout session not completed, please contact support or try again";
        }
      } catch (error) {
        this.errorMsg =
          "Error retrieving checkout session, please contact support or try again";
        console.log("Error retrieving checkout session: " + error);
        return;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
